import { Avatar, Box, CircularProgress, Dialog, IconButton, Tooltip, Typography, useTheme } from '@mui/material'
import React, { useState } from 'react'
import { Icons, replaceSpacesesLocationsWithCDNLinks, formatDate, getTimePassedFrom } from '../../../utils/utilities'
import api from '../../../service/api'
import AdminViewDiscussionComment from '../../admin/discussions/AdminViewDiscussionComment'
import DataLoadingSpinner from '../../common/DataLoadingSpinner'
import TryAgainMessageBlock from '../../common/TryAgainMessageBlock'
import CustomChip from '../../common/CustomChip'

const AuditDiscussionViewer = ( { openState, discussion, handleClose } ) => {

    const [error, setError] = useState( null )
    const [comments, setComments] = useState( [] )
    const [loading, setLoading] = useState( false )

    const { palette, layout, border } = useTheme()

    const fetchComments = async () => {
        setLoading( true )
        try {
            const { data: { data } } = await api.discussionForum.fetchDiscussionComment( discussion._id )
            setComments( data )
            setError( null )
        } catch ( err ) {
            console.log( err )
            setError( { code: err?.response?.status, message: err?.response?.data?.message || "Opps! An error occured while trying to fetch exam question try again." } )
        } finally {
            setLoading( false )
        }
    }

    return (
        <Dialog open={openState} slotProps={{
            paper: { sx: { width: "90%", maxWidth: "1200px", padding: layout.pagePadding } }
        }}>
            <Box display="flex" flexDirection="column" gap="10px">
                <Box display="flex" alignItems="center" justifyContent="space-between"  >
                    <Box display="flex" alignItems="flex-start" gap="10px">
                        <Tooltip title={discussion.creator_data.name}>
                            <Avatar sx={{ width: "40px", height: "40px" }} src={discussion.creator_data?.user_profile_image_url} >{discussion.creator_data.name[0]}</Avatar>
                        </Tooltip>
                        <Box>
                            <Typography variant='subtitle2' display="block" fontSize="14px">{discussion.creator_data.name}</Typography>
                            <Typography component="span" color='textSecondary' display="block" fontSize="12px">{discussion.created_by}</Typography>
                        </Box>
                    </Box>
                    <IconButton onClick={handleClose}>{Icons.default.CloseIcon}</IconButton>
                </Box>
                <Box marginTop="10px">
                    <Box display="flex" gap="5px" alignItems="center" flexWrap="wrap">
                        <CustomChip value={getTimePassedFrom( discussion.created_at )} />
                        <CustomChip value={`${discussion.views} views`} />
                        <CustomChip value={`${discussion.votes.up} Upvotes`} />
                        <CustomChip value={`${discussion.votes.down} Downvotes`} />
                    </Box>
                    <Typography marginTop="5px" variant='h2' fontWeight={700} fontSize="18px">{discussion.title}</Typography>
                </Box>
                <Box overflow="auto" className='wysiwyg-text-container slim-custom-scrollbar' borderRadius="5px">
                    <Box dangerouslySetInnerHTML={{ __html: replaceSpacesesLocationsWithCDNLinks( discussion.content ) }}></Box>
                </Box>
                <Box>
                    <Typography border={border[1]} onClick={fetchComments} width="fit-content" borderRadius={layout.borderRadius} padding="10px" display="flex" gap="10px" alignItems="center" sx={{ cursor: "pointer", '&:hover': { background: palette.rowHover } }} variant='subtitle2' color="textSecondary">
                        Comments ({discussion.comment_count})
                        {loading ? <CircularProgress size={12} /> : Icons.default.DropDown}
                    </Typography>
                    {!loading && !error && comments.length > 0 && <Box marginTop="10px" className='slim-custom-scrollbar' maxHeight="400px" overflow="auto" flexGrow={1} position="relative">
                        {comments?.map( ( comment, commentPos ) => (
                            <AdminViewDiscussionComment key={comment._id} comment={comment} />
                        ) )}
                    </Box>}
                </Box>
                {loading && !error && <DataLoadingSpinner padding='0' waitingMessage="Please wait while we are fetching discussion comments..." />}
                {error && <TryAgainMessageBlock err={error.message} code={error.code} loading={loading} getData={fetchComments} />}
            </Box>
        </Dialog>
    )
}

export default AuditDiscussionViewer
